export const drawing = {
  cycleRefinements: 2,
  totalTreeRefinements: 500,
  badTreeRefinements: 150,
};
